import { useLocale } from '../../state/useLocale';
import { efficiencyLandingCopy } from '../../lib/strings/efficiency-landing';
import { efficiencyHeroCopy } from '../../lib/strings/efficiency-hero';
import { AgentLine } from './AgentLine';
import { SavingsMeter } from './SavingsMeter';

/**
 * The first view: the pitch and the start, which is one line for the
 * visitor's own agent (docs/server-workspace.md, 6), beside the live savings
 * card. Nothing here downloads. The in-browser machine stays one quiet link
 * away, `byHandHref`, and says what it downloads before anybody presses it.
 *
 * Kept short on purpose (owner, 2026-10-31: "too much text"): the evidence
 * and its limits are one footnote on the card and the report behind it.
 */
export function SavingsHero({ byHandHref }: { byHandHref: string }) {
  const { locale } = useLocale();
  const t = efficiencyLandingCopy[locale];
  const s = efficiencyHeroCopy[locale];
  return <section className="intro efficiency-hero is-arriving" aria-labelledby="landing-title">
    <div className="intro-copy">
      <p className="label">{t.label}</p>
      <h1 className="display" id="landing-title">{t.title}<span className="efficiency-accent">{s.accent}</span></h1>
      <p className="lede">{s.intro}</p>
      <AgentLine />
      <p className="efficiency-by-hand">
        <a href={byHandHref}>{s.byHand}</a>
        <span className="note">{s.byHandNote}</span>
      </p>
    </div>
    <SavingsMeter />
  </section>;
}
